/**
 * Module with several utility google functions.
 */
(function() {

  "use strict";

  var TRAVELMODE = {
    transit: google.maps.TravelMode.TRANSIT,
    driving: google.maps.TravelMode.DRIVING
  };
  var OK = google.maps.DirectionsStatus.OK;

  define('fg-arv/google-helper',[],function() {
    var module = {
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns a journey from Google directions API.
       * @param {string} from The origin address to calculate the journey.
       * @param {string} to The destination address to calculate the journey.
       * @param {object} options Extra parameters to calculate the journey.
       * @returns The promise to handler the result.
       */
      getJourney: function(from, to, options) {
        var deferredObject = jQuery.Deferred();
        var directionsService = new google.maps.DirectionsService();
        // Defaults parameters
        var directionsRequest = {
          origin: null,
          destination: null,
          travelMode: null
        };
        if (!!from && !!to) {
          if (!!from.coordinates) {
            directionsRequest.origin = from.coordinates;
          } else {
            directionsRequest.origin = from.address;
          }
          if (!!to.coordinates) {
            directionsRequest.destination = to.coordinates;
          } else {
            directionsRequest.destination = to.address;
          }
          directionsRequest.travelMode = TRAVELMODE.transit;
          directionsRequest.provideRouteAlternatives = true;
          directionsRequest.region = 'GB';
          //using miles
          //directionsRequest.unitSystem = google.maps.UnitSystem.IMPERIAL;
        }
        // Optional parameters 
        if (options) {
          var transitOptions = {};

          if (options.departureTime) {
            transitOptions.departureTime = options.departureTime;
          }
          if (options.arrivalTime) {
            transitOptions.arrivalTime = options.arrivalTime;
          }
          if (options.modes) {
            transitOptions.modes = options.modes;
          }
          if (options.routingPreference) {
            transitOptions.routingPreference = options.routingPreference;
          }

          directionsRequest.transitOptions = transitOptions;
          if (options.unitSystem) {
            directionsRequest.unitSystem = options.unitSystem.toUpperCase() === 'METRIC' ? google.maps.UnitSystem
              .METRIC : google.maps.UnitSystem.IMPERIAL
          }
        }
        //Transit mode
        directionsService.route(directionsRequest, function(resultTransit, statusTransit) {
          var routes = [];
          if (statusTransit == OK) {
            if (directionsRequest.transitOptions.routingPreference === 'LESS_WALKING') {
              routes = module.reorderRoutes(resultTransit.routes)
            } else {
              routes = resultTransit.routes;
            }
            //Driving mode
            directionsRequest.travelMode = TRAVELMODE.driving;
            directionsRequest.transitOptions = {};
            directionsService.route(directionsRequest, function(resultDriving, statusDriving) {
              if (statusDriving == OK) {
                deferredObject.resolve(routes.concat(resultDriving.routes));
              } else {
                deferredObject.reject(statusDriving);
              }
            });
          } else {
            deferredObject.reject(statusTransit);
          }
        });
        return deferredObject.promise();
      },
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns a Address from Google Geocoding API
       * @param {float} lat latitude coordinate
       * @param {float} lng longitude coordinate
       * @returns  Return a promise with  the closest address to the passed lat/lng , null otherwise.
       */
      getAddressLocationFromLatLngValues: function(lat, lng) {
        var latlng = new google.maps.LatLng(+lat, +lng);

        return this.getAddressLocationFromLatLngObject(latlng);
      },
      /**
       * Returns a Address from Google Geocoding API
       * @param {google.maps.LatLng} latLong google.maps.LatLng object
       * @returns  Return a promise with the closest address to the passed lat/lng , null otherwise.
       */
      getAddressLocationFromLatLngObject: function(latLng) {
        if (!(latLng instanceof google.maps.LatLng)) {
          return null;
        }
        var deferred = jQuery.Deferred();
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'location': latLng
        }, function(results, status) {
          //geocoder.geocode({'latLng': latlng}, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              var result = results[0];
              var normalizeObject = {
                code: result.place_id,
                name: result.formatted_address,
                coordinates: {
                  lat: result.geometry.location.lat(),
                  lng: result.geometry.location.lng()
                },
                country: result.formatted_address.split(',')[result.formatted_address.split(',').length -
                  1]
              };
              deferred.resolve(normalizeObject);
            }
          } else {
            deferred.reject(status);

          }
        });

        return deferred.promise();

      },

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns a Geocode from Google Geocoding API
       * @param {string} name The name or address to calculate the latLong coordinate
       * @returns  Return a promise with the google LatLng object of the passed address, null otherwise.
       */
      getGeocodeLocationFromName: function(name) {
        if (typeof name !== 'string') {
          return null;
        }
        var deferred = jQuery.Deferred();
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'address': name
        }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var result = results[0];
            var normalizeObject = {
              code: result.place_id,
              name: result.formatted_address,
              coordinates: {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng()
              }
            };
            deferred.resolve(normalizeObject);
          } else {
            deferred.reject(status);
          }
        });
        return deferred.promise();
      },
      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns an object with the details of a place
       * @param {string} reference String of place reference
       * @param {google.maps.Map} map The google map instance
       * @returns returns an object with the details of a place
       */

      getPlace: function(code) {
        var _deferred = jQuery.Deferred(),
          geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'placeId': code
        }, function(places, status) {
          if (status !== 'OK') {
            _deferred.reject(status);
          } else {
            _deferred.resolve(places[0]);
          }
        });
        return _deferred.promise();
      },

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Returns a list with predictions
       * @param {string} text String to search
       * @param {google.maps.Map} map The google map instance
       * @returns returns a list with predictions
       */
      getPlacesPredictions: function(text, map) {
        if (typeof text !== 'string' || !(map instanceof google.maps.Map)) {
          throw new Error('The text or the map is missing');
        }
        var deferred = jQuery.Deferred();
        var service = new google.maps.places.AutocompleteService();

        service.getQueryPredictions({
          input: text,
          location: map.getCenter(),
          radius: 50000,
          componentRestrictions: {
            country: 'uk'
          }
        }, callback);

        function callback(results, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            var normalizeResults = [];
            for (var i = 0; i < results.length; i++) {
              var result = results[i];
              if (result.reference) {
                var normalizeObject = {
                  code: result.reference,
                  name: result.description,
                  coordinates: function() {
                    var _deferred = jQuery.Deferred();
                    module.getPlace(this.code, map).done(function(place) {
                      if (!place) {
                        _deferred.reject();
                      }
                      var location = {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                      };
                      _deferred.resolve(location);
                    }).fail(function() {
                      _deferred.reject(status);
                    });
                    return _deferred.promise();
                  },
                  originData: result
                };
                normalizeResults.push(normalizeObject);
              }
            }
            deferred.resolve(normalizeResults);
          } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            deferred.resolve([]);
          } else {
            deferred.reject(status);
          }

        }

        return deferred.promise();
      },

      //------------------------------------------------------------------------------------------------------------------------------
      /**
       * Reorder routes less walking
       */
      reorderRoutes: function(routes) {
        for (var i in routes) {
          var steps = routes[i].legs[0].steps;
          var distance = 0;
          var hasWalkingStep = false;
          for (var j in steps) {
            if (steps[j].travel_mode === 'WALKING') {
              distance += steps[j].distance.value;
              hasWalkingStep = true;
            }
          }
          if (hasWalkingStep && distance === 0) {
            distance = 0.001;
          }
          routes[i].distance = distance;
        }
        //bubble sort
        var swapped;
        do {
          swapped = false;
          for (var i = 0; i < routes.length - 1; i++) {
            if (routes[i].distance > routes[i + 1].distance) {
              var temp = routes[i];
              routes[i] = routes[i + 1];
              routes[i + 1] = temp;
              swapped = true;
            }
          }
        } while (swapped);
        return routes;
      }

    };
    return module;
  });
})();

